import { By, ObjectId, Timestamp } from "../../../types";
import { ActivityRendererType } from "../types";

export enum FactorActivityAction {
  None = 0,
  Receive,
  Update,
  Delete,
  Spend,
}

export interface FactorActivityReceive {
  customer: ObjectId;
  description: string;
  total_price: number;
  factor: ObjectId;
  cheques: ObjectId[];
}

export interface FactorActivityUpdate {
  customer: ObjectId;
  description: string;
  total_price: number;
  factor: ObjectId;
  cheques: ObjectId[];
}

export interface FactorActivityDelete {
  customer: ObjectId;
  description: string;
  total_price: number;
  cheques: ObjectId[];
}

export interface FactorActivitySpend {
  customer: ObjectId;
  description: string;
  total_price: number;
  factor: ObjectId;
  cheques: ObjectId[];
}

export type FactorActivityData =
  | FactorActivityReceive
  | FactorActivityUpdate
  | FactorActivityDelete
  | FactorActivitySpend;

export interface FactorActivity {
  action: FactorActivityAction;
  data: FactorActivityData;
}

export interface FactorActivityDataWithType {
  type: ActivityRendererType;
  activity: FactorActivityData;
  date: Timestamp;
  by: By;
}
